export default __webpack_public_path__ + "static/media/Single_Arrow_Edit.538cdcff.svg";